import { useMutation } from 'react-query';

import { CurrentStageAndConfig, getCurrentStageAndConfig } from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';
import { apiEndpoints } from '../constants/ApiConstants';
import { IUserAuthAttributes } from '../types/UserAuth.types';
import { auth } from '../ApiClient';

export function useLogoutUserMutation() {
  return useMutation<IUserAuthAttributes, Error>(logoutUser);
}

export async function logoutUser(): Promise<IUserAuthAttributes> {
  const { config:currentStage }: CurrentStageAndConfig = getCurrentStageAndConfig();

  const authPortalUrlReq = {
    domain: currentStage.domain,
    associationHandle: currentStage.associationHandle,
    returnToUrl: currentStage.returnToUrl,
    pageId: currentStage.pageId,
  };

  const authHeaders = {
    headers: {
      AuthPortalUrlRequest: JSON.stringify(authPortalUrlReq),
    },
  };

  const body = {
    domain: currentStage.domain,
    associationHandle: currentStage.associationHandle,
    returnToUrl: currentStage.returnToUrl,
  };

  const response = await auth.post(apiEndpoints.logout, body, authHeaders);
  localStorage.clear();
  return response?.data;
}
